import { CalendarClock, Clock, UserCog, Wallet } from "lucide-react";
import { HELP_STATIC_CATEGORIES, type HelpStaticKey } from "../../utils/helpCenter";

export interface HelpCategoryTile {
    key: HelpStaticKey;
    articleCount: number;
}

interface HelpCategoriesProps {
    categories: HelpCategoryTile[];
    onCategoryClick: (categoryKey: HelpStaticKey) => void;
}

const STATIC_ICONS: Record<string, React.ReactNode> = {
    Clock: <Clock size={22} />,
    CalendarClock: <CalendarClock size={22} />,
    Wallet: <Wallet size={22} />,
    UserCog: <UserCog size={22} />,
};

export { STATIC_ICONS };

/** Figma static category tiles: colored icon tile + label + count (dc.html:1832). */
export function HelpCategories({ categories, onCategoryClick }: HelpCategoriesProps) {
    return (
        <div className="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
            {HELP_STATIC_CATEGORIES.map((meta) => {
                const count = categories.find((c) => c.key === meta.key)?.articleCount ?? 0;
                const countLabel = `${count} ${count === 1 ? "article" : "articles"}`;
                return (
                    <button
                        key={meta.key}
                        type="button"
                        onClick={() => onCategoryClick(meta.key)}
                        className="bg-[var(--color-bg-base)] border border-[var(--color-border-primary)] rounded-card shadow-[var(--shadow-sm)] p-[22px] text-left cursor-pointer transition-all duration-200 hover:-translate-y-[3px] hover:shadow-[var(--shadow-md)] focus-visible:ring-2 focus-visible:ring-[var(--color-primary-500)] focus-visible:outline-none"
                    >
                        <span className={`w-[46px] h-[46px] rounded-md grid place-items-center ${meta.tileBg}`}>
                            <span className={meta.tileColor}>{STATIC_ICONS[meta.icon] ?? <Clock size={22} />}</span>
                        </span>
                        <div className="mt-3.5 text-body-md font-bold text-[var(--color-text-primary)] line-clamp-2">
                            {meta.label}
                        </div>
                        <div className="mt-[3px] text-body-xs text-[var(--color-text-tertiary)]">
                            {countLabel}
                        </div>
                    </button>
                );
            })}
        </div>
    );
}

export default HelpCategories;
